'use strict';

var React = require('react');
var _ = require('underscore');
var styleHelper = require('../../helper/styleHelper');
/**
 * @author mengxiaojiang
 * @createData 2016-6-14
 * @descriptor 垂直分隔条
 */
var VerticalSplitter = React.createClass({
  render : function(){
    return (<div className="component component-VerticalSplitter">
      <ul style={{paddingTop : (styleHelper.getHeight(this.props) - 15) / 2}}>
        <li/>
        <li/>
        <li/>
      </ul>
    </div>);
  }
});

module.exports = VerticalSplitter;



// WEBPACK FOOTER //
// ./src/views/Components/VerticalSplitter.jsx